(function () {
  var MAX = 5;

  function clean(value) {
    return (value || '')
      .toUpperCase()
      .replace(/[^A-ZÁÉÍÓÚÑ&.\- ]/g, '')
      .replace(/\s{2,}/g, ' ')
      .slice(0, MAX);
  }

  function wire(scope) {
    if (scope.dataset.mbBound === '1') return;
    scope.dataset.mbBound = '1';

    var input = scope.querySelector('[data-mb-perso-input]');
    var out = scope.querySelector('[data-mb-perso-text]');
    var count = scope.querySelector('[data-mb-perso-count]');
    var colorName = scope.querySelector('[data-mb-perso-colorname]');
    var colors = scope.querySelectorAll('[data-mb-perso-color]');

    function paintText() {
      if (!input) return;
      var value = clean(input.value);
      if (input.value !== value) input.value = value;
      if (out) {
        out.textContent = value;
        out.classList.toggle('is-on', value.length > 0);
      }
      if (count) count.textContent = String(MAX - value.length);
    }

    function paintColor(radio) {
      if (!radio) return;
      if (out) out.style.color = radio.getAttribute('data-mb-perso-color');
      if (colorName) colorName.textContent = radio.value;
    }

    if (input) {
      input.addEventListener('input', paintText);
      input.addEventListener('blur', paintText);
    }

    colors.forEach(function (radio) {
      radio.addEventListener('change', function () { paintColor(radio); });
      if (radio.checked) paintColor(radio);
    });

    paintText();
  }

  function init() {
    document.querySelectorAll('[data-mb-perso]').forEach(wire);
  }

  document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('shopify:section:load', init);
  if (document.readyState !== 'loading') init();
})();
